import { STATUS } from '@/constants';
import useToastStore from '@/stores/toast/toastStore';

const useToast = () => {
  const addToast = useToastStore((state) => state.addToast);
  const removeToast = useToastStore((state) => state.removeToast);
  const addSuccessToast = (toast) => {
    addToast({ ...toast, type: STATUS.SUCCESS });
  };

  const addErrorToast = (toast) => {
    addToast({ ...toast, type: STATUS.ERROR });
  };

  const addWarningToast = (toast) => {
    addToast({ ...toast, type: STATUS.WARNING });
  };

  return { addSuccessToast, addErrorToast, addWarningToast, removeToast };
};

export default useToast;
